import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { applicationCustomerList } from './../../customer/applicationManage/request';
import { editCustomer, addCustomer, customerDetail, getCountryResource } from './request';
import { isPhone, checkEmail } from '@/utils/validate';
import applicationModel from './../../customer/applicationManage/applicationModel.vue';
import difference from 'lodash/difference';
export default {
  components: {
    applicationModel
  },
  name: 'customerModel',
  props: ['id'],
  data() {
    return {
      dataFrom: {},
      appType: '',
      dialogVisible: false,
      mockData: [],
      targetKeys: [],
      TableColumns: [{
        dataIndex: 'title',
        slots: {
          title: '名称'
        }
      }, {
        dataIndex: 'description',
        slots: {
          title: '牌照所属'
        }
      }],
      showSearch: false,
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }],
      countryOptionData: []
    };
  },
  computed: {
    roleRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('姓名')
        }],
        responsible: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('负责人')
        }],
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePhone
        }],
        isLicense: [{
          required: true,
          message: this.$t('请选择') + this.$t('保险牌照'),
          trigger: 'change'
        }],
        appType: [{
          required: true,
          validator: this.appTypeCheck,
          trigger: 'change'
        }],
        appIds: [{
          required: true,
          trigger: 'change',
          type: 'array',
          validator: this.appIdsCheck
        }],
        account: [{
          required: true,
          message: this.$t('请输入账号'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9@.]+$/,
          message: this.$t('仅限输入大小写字母、数字、特殊符号“@”和“.”'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 50,
          message: this.$t('请输入8-50字符'),
          trigger: 'blur'
        }],
        countryId: [{
          required: true,
          message: this.$t('请选择') + this.$t('业务发生地'),
          trigger: 'change'
        }],
        email: [{
          required: false,
          validator: this.checkEmail,
          trigger: 'blur'
        }]
      };
    }
  },
  async created() {
    if (this.id != -1) {
      console.log('this.id != -1');
      await customerDetail({
        customerId: this.id
      }).then(res => {
        this.dataFrom = {
          customerId: res.id,
          name: res.name,
          responsible: res.responsible,
          mobile: res.mobile,
          isLicense: res.isLicense,
          account: res.account,
          englishName: res.englishName,
          email: res.email,
          globalRoaming: res.globalRoaming,
          countryId: res.countryId
        };
        if (res.applicationIds) {
          this.appType = '2';
          this.getapplicationCustomerFun();
          res.applicationIds.map(item => {
            this.targetKeys.push(String(item));
          });
        } else {
          this.appType = '1';
        }
      });
    }
    if (this.id == -1) {
      console.log('this.id == -1');
      // 原始
      // let globalRoaming = sessionStorage.getItem('globalRoaming') ||   '86';
      // 修改后
      let globalRoaming = sessionStorage.getItem('globalRoaming') || "process.env.VUE_APP_BASE_API?.includes('console.insureforce.cn')? '+86': '+1'";
      this.$set(this.dataFrom, 'globalRoaming', globalRoaming);
    }
    await getCountryResource({}).then(res => {
      this.countryOptionData = res;
    });
  },
  methods: {
    checkEmail(rule, value, callback) {
      let regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !regEmail.test(value)) {
        callback(new Error(this.$t('邮箱有误，请重新填写')));
      } else {
        callback();
      }
    },
    handleBlurTrim(key) {
      this.dataFrom[key] = this.dataFrom[key].trim();
    },
    changeGlobalRoaming() {
      this.$set(this.dataFrom, 'mobile', '');
      // this.$refs.roleFrom.validateField('mobile');
    },
    phoneCheck(rule, value, callbackFn) {
      if (!isPhone(value)) {
        callbackFn(this.$t('请输入') + this.$t('手机号码'));
        return;
      }
      callbackFn();
    },
    appIdsCheck(rule, value, callbackFn) {
      if (this.targetKeys.length == 0 && this.appType == '2') {
        callbackFn(this.$t('请分配应用'));
        return;
      }
      callbackFn();
    },
    appTypeCheck(rule, value, callbackFn) {
      if (!this.appType) {
        callbackFn(this.$t('请选择应用管理'));
        return;
      }
      callbackFn();
    },
    validatePhone(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // 台湾
        HK: /^([6|9])\d{7}$/,
        // 香港
        MO: /^[6]\d{7}$/,
        // 澳门
        US: /^[1-9]\d{9}$/,
        // 美国
        SG: /^[89]\d{7}$/ // 新加坡
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.dataFrom.globalRoaming);
      console.log(findItem, '${tableEd}');
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('联系方式')));
      } else if (!regValue.test(value)) {
        callback(new Error(this.$t('联系方式格式有误，请重新填写')));
      } else {
        callback();
      }
    },
    validateAccount(rule, value, callback) {
      let reg = /^[\w@.\-_]+$/;
      if (value.trim().length === 0) {
        callback(new Error(this.$t('用户名不能为空')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字或特殊字符“@”和“.”“-”“_”')));
      } else {
        callback();
      }
    },
    getapplicationCustomerFun() {
      applicationCustomerList({}).then(res => {
        res.map(item => {
          this.mockData.push({
            key: String(item.appId),
            title: item.appName,
            description: item.cusName
          });
        });
      });
    },
    appTypeChange() {
      if (this.appType == '2') {
        this.getapplicationCustomerFun();
      } else {
        this.mockData = [];
        this.targetKeys = [];
      }
    },
    handleChange(nextTargetKeys) {
      this.targetKeys = nextTargetKeys;
    },
    handleSearch(dir, value) {},
    onSubmit() {
      this.$refs.roleFrom.validate(valid => {
        if (valid) {
          // if (this.dataFrom.email) {
          //   if (!checkEmail(this.dataFrom.email)) {
          //     return this.$message.error(this.$t('请输入') + this.$t('正确的邮箱'));
          //   }
          // }
          this.dataFrom.appIds = this.targetKeys.length != 0 ? this.targetKeys : undefined;
          let fun = this.id == -1 ? addCustomer : editCustomer;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功'));
            this.$emit('ok', res);
          });
        }
      });
    },
    handleOk(val) {
      this.dialogVisible = false;
      this.getapplicationCustomerFun();
      this.targetKeys.push(String(val.applicationId));
    },
    triggerShowSearch(showSearch) {
      this.showSearch = showSearch;
    },
    getRowSelection({
      disabled,
      selectedKeys,
      itemSelectAll,
      itemSelect
    }) {
      return {
        getCheckboxProps: item => ({
          props: {
            disabled: disabled || item.disabled
          }
        }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.filter(item => !item.disabled).map(({
            key
          }) => key);
          const diffKeys = selected ? difference(treeSelectedKeys, selectedKeys) : difference(selectedKeys, treeSelectedKeys);
          itemSelectAll(diffKeys, selected);
        },
        onSelect({
          key
        }, selected) {
          itemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys
      };
    }
  }
};